import * as React from 'react';
import {WithStyles, withStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { connect } from "react-redux";
import { DayDetailsStyle } from './DayDetails.style';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IScheduleEvent } from './scheuldeEvent.types';
import { ICompleteTodo, ITodo, RENEWAL, IHideTodo } from '@app-types/websocket/todo.types';
import DoneIcon from "@material-ui/icons/Done";
import ArrowIcon from "@material-ui/icons/ArrowForwardIosRounded";
import DoneIconDouble from "@material-ui/icons/DoneOutlineRounded";
import AddIcon from "@material-ui/icons/AddRounded";
import * as TodoActions from '@services/todos/todo.action';
import { CheckMark } from '@components/guide/components/CheckMarkSvg';
import { Link } from 'react-router-dom';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof DayDetailsStyle> {
  userId:number;
  event: IScheduleEvent;
  family:IFamilyMember[];
  schoolAge:number;
  type:"start"|"end"
  barOneBackground?:React.CSSProperties;
  barTwoBackground?:React.CSSProperties;
  barThreeBackground?:React.CSSProperties;
  hideThis:boolean;

  showDetails:() => void;
  completeTodo:(completed:ICompleteTodo) => void;
  seenTodo:(todo:IHideTodo) => void;
  completeHandover:(scheduleId:number) => void;
  editTodo:(todo:ITodo|undefined) => void;
  addPackingListItem:(scheduleId:number) => void;
}

interface IState {
  collapsed: boolean;
}

class DayScheduleEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      collapsed: true,
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    return;
  }

  public componentDidMount() {
    return;
  }

  public render() {
    const {classes,event, family, userId, hideThis} = this.props;

    if (hideThis) {
      return (<div style={{display:'none'}}/>);
    }


    const backgroundStyle:React.CSSProperties = { };
    let borderRadius:string = "";

    if (this.props.type === "start") {
      backgroundStyle.backgroundColor = event.parentColor;
      backgroundStyle.height = '9px';
      backgroundStyle.width = 'calc(100% - 71px)';
      backgroundStyle.borderRadius = '10px 10px 10px 10px';
      borderRadius = ' '+classes.startBand;
    } else {
      borderRadius = ' '+classes.endBand;
    }

    let packingList:JSX.Element|null = null;
    if (this.props.type === "end" && (this.props.event.packingListStatus === "current")) {
      const droppingOf:number = event.parent;
      const pickingUp:number = event.schedule.data.parentA === event.parent?event.schedule.data.parentB:event.schedule.data.parentA;
  
      let packingOpacity = this.state.collapsed?1:0;
      let checkmarkOpacity = this.state.collapsed?1:0;
      let myTodoCount:number = 0;
      let myUnseenTodoCount:number = 0;

      for (const it of this.props.event.packingList) {
        if (it.completedBy === undefined || it.completedBy === 0) {
          myTodoCount++;
          if (it.seen && !it.seen.includes(this.props.userId)) {
            myUnseenTodoCount++;
          }
        }
      }
      if (myTodoCount === 0) {
        packingOpacity = 0;
      } else {
        checkmarkOpacity = 0;
      }

      let cname:string = classes.packingList;
      if (this.state.collapsed) {
        cname +=(" "+classes.packingListCollapsed);
      }
      if (myUnseenTodoCount > 0) {
        // cname +=(" "+classes.packingListHighlight);
        packingOpacity = 1;
      }

      packingList = <div key="packinglist" className={classes.packingList}>
        <Link style={{ textDecoration: "none", color:styleColors.primaryTextBlack87}} to={"/app/notes/0"} >
          
          <div className={classes.packingListHeader}           >
            <div className={classes.packingListBadge} style={{opacity:(packingOpacity), top:'unset', left:'unset'}}>{myTodoCount}</div>
            <div className={classes.packingListCheckmark} style={{opacity:(checkmarkOpacity), position:'initial'}}>
              <DoneIconDouble style={{maxWidth: '18px',maxHeight: '18px'}}/>
            </div>
            <span style={{paddingLeft: '24px', flex: 1, fontWeight: 300, fontSize:'17px'}}>{tn.lang.calPackingList}</span>
            <div style={{ alignSelf: 'center', color: styleColors.greyMedium2}}>
              <ArrowIcon />
            </div>
          </div>
        </Link></div>
/*
      <div key="packinglist" className={cname} >
        <Link style={{ textDecoration: "none", color:styleColors.greyDark1, display:'flex', alignItems: 'center'}} to={"/app/notes/0"} >
          <div className={classes.packingListBadge} style={{opacity:(packingOpacity), position:'initial'}}>{myTodoCount}</div>
          <div className={classes.packingListCheckmark} style={{opacity:(checkmarkOpacity), position:'initial'}}>
            <DoneIconDouble style={{maxWidth: '18px',maxHeight: '18px'}}/>
          </div>
          <div className={classes.packingListHeader} >
            <span style={{flex:1, paddingLeft: '3px'}}>{tn.lang.calPackingList}</span>
            <div style={{marginLeft:'8px', alignSelf: 'center', color: styleColors.greyMedium2}}>
              <ArrowIcon />
            </div>
          </div>
        </Link>
      </div> */
    } else if (this.props.type === "end" && (this.props.event.packingListStatus === "generate")) {
      packingList = // generate the packing list button
      <div key="packinglist" className={classes.packingList}>
        <Link style={{ textDecoration: "none", color:styleColors.primaryTextBlack87}} to={"/app/notes/0"} >
          
          <div className={classes.packingListHeader}           >
            <div className={classes.packingListBadge} style={{opacity:1, top:'unset', left:'unset'}}>{""}</div>
            <span style={{paddingLeft: '24px', flex: 1, fontWeight: 300, fontSize:'17px'}}>{tn.lang.calPackingList}</span>
            <div style={{ alignSelf: 'center', color: styleColors.greyMedium2}}>
              <ArrowIcon />
            </div>
          </div>
        </Link>
      </div>
    }

    return (

        <div  className={classes.event}>
          <div className={classes.eventScheduleData} style={this.props.type==="start"?{paddingTop:'22px'}:{}}>
            <div className={classes.eventColorBand} style={{backgroundColor:event.parentColor}}/>
            <div style={{flex:1}}>
              <div className={classes.eventData} onClick={() => this.props.showDetails()} >
                <div className={classes.scheduleEventTime}>
                  <div className={classes.eventTimeBox}>
                    {this.props.type === "start"
                      ?event.startAtSchool
                        ?(tn.lang.schoolAge(this.props.schoolAge, event.schedule.school))
                        :(tn.formatTime(new Date(event.startTime)))
                      :event.endAtSchool
                        ?(tn.lang.schoolAge(this.props.schoolAge, event.schedule.school))
                        :(tn.formatTime(new Date(event.endTime)))}
                  </div>
                </div>
                <div style={{flex:1}}>
                  <div className={classes.eventItemTopRow} >
                    <div className={classes.eventDescBox}>
                      {this.props.family
                      .filter((person) => (event.parent  === person.id))
                      .map((person, index) =>
                        <span style={{display: 'inline-flex'}} key={person.id}>{tn.familyMemberNames(event.children, family)} {tn.lang.at}
                          <ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
                            imgName={person.avatar} style={{width:'18px', height:'18px', marginLeft: '3px'}} 
                            color={person.color} />
                        </span>)}
                    </div>
                  </div>
                  <div className={classes.eventItemRow} >
                    <div className={classes.eventDescBox}>
                      <p className={classes.eventDescriptionText}>
                        {(this.props.type === "start"
                          ?(event.startAtSchool
                            ?tn.lang.schedulePickupSchool(event.schedule.school, this.props.schoolAge)
                            :tn.lang.handoverLocation+(event.startLoc?event.startLoc:tn.lang.unknown))
                          :(event.endAtSchool
                            ?tn.lang.scheduleDropoffSchool(event.schedule.school, this.props.schoolAge)
                            :tn.lang.handoverLocation+(event.endLoc?event.endLoc:tn.lang.unknown)))}
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{marginLeft:'8px', alignSelf: 'center', color: styleColors.greyMedium2, marginRight: '5px'}}>
                  <ArrowIcon />
                </div>
              </div>
              {packingList}
            </div>
          </div>
          <div className={classes.eventScheduleBands}>
            <div className={classes.eventScheduleBand+borderRadius} style={this.props.barTwoBackground}/>
            <div className={classes.eventScheduleBand+borderRadius} style={this.props.barOneBackground}/>
            <div className={classes.eventScheduleBand+borderRadius} style={this.props.barThreeBackground}/>
          </div>
          {/* <div className={classes.eventLine} style={backgroundStyle}/> */}
        </div>
    );
  }

  private seen(packingList:ITodo[]) {
    for (const pl of packingList) {
      if (pl.seen === undefined || !pl.seen.includes(this.props.userId)) {
        this.props.seenTodo({id:pl.id});
      }
    }
  }

  private completePackingListItem(item:ITodo) {
    if (item.completedBy === undefined ) {
      this.props.completeTodo({complete:true, id:item.id})
    } else {
      this.props.completeTodo({complete:false, id:item.id})
    }
    
  }

}

const mapDispatchToProps = {
  completeTodo: TodoActions.completeTodo,
  seenTodo: TodoActions.seenTodo,
  completeHandover: TodoActions.completeHandover,
};

export default connect(null, mapDispatchToProps)(withStyles(DayDetailsStyle)(DayScheduleEvent));



// WEBPACK FOOTER //
// ./src/components/calendar2/dayDetails/DayScheduleEvent.tsx